module.exports = __webpack_public_path__ + "img/record.3f406a13.png";